module.exports = __webpack_public_path__ + "static/affiliate/affiliate-insurance@2x-a2e9bb023ebf2487a9366b32de561f88.jpg";